import { SET_USERS_OF_COMPANY } from "../actions/action-types";

const initialState = [];

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const companyUsers = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS_OF_COMPANY:
      return action.payload;
    default:
      return state;
  }
};

export default companyUsers;
